<template>
  <div class="print-pdf unit container edit-user-unit-container">
    <div class="pdf-background-img-container">
      <div class="pdf-background-image"></div>
    </div>
    <div class="contentSection pt-16">
      <div v-if="isFetching" class="pa-8 text-center">
        <v-progress-circular indeterminate size="28" class="mr-2" />
        Loading section…
      </div>
      <div v-else-if="prevSection">
        <div class="">
          <div class="close-link" @click="closebuilder">
            <v-icon>arrowleft</v-icon>
            <span class="close-link-text">BACK TO EDIT SECTION</span>
          </div>
        </div>
        <div>
          <div class="unit-meta-container">
            <div class="mb-0 mt-4">
              <h2
                id="unit-title"
                class="base-year"
                v-html="prevSection.title"
              ></h2>
            </div>
          </div>

          <v-row>
            <v-col
              cols="12"
              v-for="(prevUnit, index) in prevSection.selectedUnits || []"
              :key="index"
            >
              <div class="unit-meta-container">
                <div class="mb-0 mt-4">
                  <h2
                    id="unit-title"
                    class="base-year"
                    v-html="prevUnit.title"
                  ></h2>
                </div>
                <div class="mb-7 mt-0">
                  <span
                    class="font-weight-bold"
                    v-html="prevUnit.subtitle"
                  ></span>
                </div>
              </div>

              <v-divider class="dashed my-10"></v-divider>

              <div id="start" class="font-weight-bold px-10 mb-3">
                UNIT ASSIGNMENTS
              </div>
              <div class="unit-assignments px-10 mb-10">
                <div v-if="prevUnit.listen">
                  <div class="flex-this mb-3">
                    <v-checkbox
                      v-model="listenConfirmed"
                      hide-details
                      disabled
                      class="mt-0 pt-0"
                    >
                      <template #label>
                        <div class="flex-this" style="margin-top: 2px">
                          <span class="font-weight-bold"
                            >{{ prevUnit.listenLabel }}:</span
                          >
                        </div>
                      </template>
                    </v-checkbox>
                    <span v-html="prevUnit.listen" class="label-text"></span>
                  </div>
                </div>
                <div v-if="prevUnit.complete">
                  <div class="flex-this mb-3">
                    <v-checkbox
                      v-model="completeConfirmed"
                      hide-details
                      disabled
                      class="mt-0 pt-0"
                    >
                      <template #label>
                        <div class="flex-this" style="margin-top: 2px">
                          <span class="font-weight-bold"
                            >{{ prevUnit.completeLabel }}:</span
                          >
                        </div>
                      </template>
                    </v-checkbox>
                    <span v-html="prevUnit.complete" class="label-text"></span>
                  </div>
                </div>
                <div v-if="prevUnit.continueLearning">
                  <div class="flex-this">
                    <v-checkbox
                      v-model="continueConfirmed"
                      hide-details
                      disabled
                      class="mt-0 pt-0"
                    >
                      <template #label>
                        <div class="flex-this" style="margin-top: 2px">
                          <span class="font-weight-bold"
                            >{{ prevUnit.continueLearningLabel }}:</span
                          >
                        </div>
                      </template>
                    </v-checkbox>
                    <span
                      v-html="prevUnit.continueLearning"
                      class="label-text"
                    ></span>
                  </div>
                </div>
              </div>

              <div id="truth" class="break-page-after">
                <div class="flex-container mt-5">
                  <div class="font-weight-bold text-h6 base-year">TRUTH</div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <UserVersesQuotes
                  :content="prevUnit.truthVersesQuotes"
                  section="truthVersesQuotes"
                />

                <v-divider
                  v-if="prevUnit.truthVersesQuotes"
                  class="dashed"
                ></v-divider>

                <div
                  v-if="prevUnit.truthInBible"
                  v-html="prevUnit.truthInBible"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="prevUnit.truthStudyQuestions"
                  section="truthStudyQuestions"
                  @allstudyquestions="studyQuestionsChild"
                />

                <div
                  v-if="prevUnit.truthBodyContent"
                  v-html="prevUnit.truthBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>
              </div>

              <div id="equip" class="break-page-after">
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    EQUIPPING
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-if="prevUnit.equipBodyContent"
                  v-html="prevUnit.equipBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="prevUnit.equipStudyQuestions"
                  section="equipStudyQuestions"
                  @allstudyquestions="studyQuestionsChild"
                />
              </div>

              <div id="application" class="break-page-after">
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    ACCOUNTABILITY
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-if="prevUnit.accountBodyContent"
                  v-html="prevUnit.accountBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="prevUnit.accountStudyQuestions"
                  section="accountStudyQuestions"
                  @allstudyquestions="studyQuestionsChild"
                />
              </div>

              <div
                v-if="prevUnit.footnotesBodyContent"
                class="break-page-after"
              >
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    FOOTNOTES
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-html="prevUnit.footnotesBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-else>No Unit to preview.</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import PreviewStudyQuestions from '@/components/utilities/PreviewStudyQuestions'
  import UserVersesQuotes from '@/components/utilities/UserVersesQuotes'
  import { hydratePreviewFromRoute } from '@/helpers/previewBridge'

  export default {
    name: 'PreviewSection',
    components: {
      PreviewStudyQuestions,
      UserVersesQuotes,
    },
    data() {
      return {
        feedback: null,
        unitbackdoor: 0,
        backdoor: 0,
        listenConfirmed: null,
        completeConfirmed: null,
        continueConfirmed: null,
        isFetching: false,
        fetchDelay: 500,
      }
    },
    computed: {
      ...mapState('UserData', ['user']),
      ...mapState('AppData', [
        'userActiveCourse',
        'prevSection',
        'prevSectionId',
      ]),
      ...mapGetters('AppData', ['getCourse', 'getActiveCourse']),
      ...mapGetters('UserData', ['getRoles']),
    },
    methods: {
      init() {
        this.unitbackdoor++
      },
      closebuilder() {
        window.close()
      },
      studyQuestionsChild(value) {
        // update the property with any Study Questions
        if (value.section === 'truthStudyQuestions') {
          this.prevUnit.truthStudyQuestions = value.questions?.length
            ? value.questions
            : []
        }
        if (value.section === 'equipStudyQuestions') {
          this.prevUnit.equipStudyQuestions = value.questions?.length
            ? value.questions
            : []
        }
        if (value.section === 'accountStudyQuestions') {
          this.prevUnit.accountStudyQuestions = value.questions?.length
            ? value.questions
            : []
        }
      },
      versesQuotesChild(value) {
        // update the property with any Study Questions
        if (value.section == 'truthVersesQuotes') {
          if (value.versesquotes.length)
            this.prevUnit.truthVersesQuotes = value.versesquotes
          else this.prevUnit.truthVersesQuotes = []
        }
      },
    },
    async created() {
      this.isFetching = true
      const delay = new Promise((res) => setTimeout(res, this.fetchDelay))
      const load = hydratePreviewFromRoute({
        route: this.$route,
        store: this.$store,
        type: 'section',
      })

      await Promise.all([load, delay])
      this.isFetching = false
      this.init()
    },
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }
  #truth
    :deep(p, )
    #equip
    :deep(p, )
    #application
    :deep(p, )
    #mission
    :deep(p, )
    #supplication
    :deep(p, )
    #truth
    :deep(img, )
    #equip
    :deep(img, )
    #application
    :deep(img, )
    #mission
    :deep(img, )
    #supplication
    :deep(img) {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 16px;
    padding-bottom: 12px;
    margin-bottom: 0px;
  }

  .print-content-container,
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .unit.container {
    max-width: 800px;
    margin-left: 10vw;
  }
  .unit.container .background-img-container {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .unit.container .pdf-background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(../../assets/mountains_bw.jpg) no-repeat 50% 0;
    background-size: cover;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    /*filter: grayscale(100%) blur(0px);*/
  }
  .theme--dark .unit.container .background-image {
    filter: grayscale(100%) blur(0px) invert(1);
  }
  .pdf-background-image-donotuse:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.85);
  }
  .unit .contentSection {
    /* margin-bottom: 50%; */
    /* max-height: 90vh;
    overflow: hidden; */
    position: relative;
  }
  .edit-user-unit-container.blueYear :deep(a) {
    color: #002b45;
  }
  .edit-user-unit-container.redYear :deep(a) {
    color: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(a) {
    color: #024731;
  }
  .flex-this {
    display: flex;
    align-items: center;
  }
  .edit-user-unit-container :deep(img) {
    max-width: 100%;
  }
  .unit-assignments :deep(p) {
    margin-bottom: 0;
  }
  .unit-assignments :deep(label) {
    text-transform: none;
  }
  .label-text {
    margin-left: 5px;
    font-size: 13px;
    padding-top: 2px;
  }
  .unit-assignments :deep(.v-input__slot) {
    align-items: start;
  }
  @media only screen and (max-width: 767px) {
    .flex-this {
      flex-direction: column;
    }
  }
</style>
